import { useEffect, useRef } from "react";
import isEqual from "lodash/isEqual";
import SelectFieldModal from "../../../components/organisms/AppModals/ServiceModals/SelectFieldModal";
import { CustomRadioButton } from "../../../components/atoms";
import { EMPTY_ARRAY } from "../../../constants";
import { ManageExpression } from "../ServiceFields";
import { FIELDS as nodeFields } from "../../../pages/DataModels/datamodels.constants";

const { EXPRESSION } = nodeFields;
const NONE = "none";
const FIELDS = "fields";
const groupByOptions = [
  { value: NONE, label: "No Grouping, perform calculations for all" },
  { value: FIELDS, label: "Group by selected fields" },
  { value: EXPRESSION, label: "Group by selected expression" },
];

const GroupBy = ({ name, values, collections, handleChange, nodes, edges }) => {
  const preSelectedValues = useRef(values[name]);
  const previousModelName = useRef(values.modelName);

  useEffect(() => {
    if (previousModelName.current !== values.modelName) {
      previousModelName.current = values.modelName;
      const value = {
        type: values[name].type,
        fields: EMPTY_ARRAY,
        expression: values[name].expression,
      };
      handleChange(value, name);
    }
  }, [values, name, handleChange]);

  useEffect(() => {
    if (values[name] && !isEqual(preSelectedValues.current, values[name])) {
      preSelectedValues.current = values[name];
      handleChange(values[name], name);
    }
  }, [values, name, handleChange]);

  return (
    <>
      <CustomRadioButton
        name={`${name}.type`}
        options={groupByOptions}
        handleChange={handleChange}
        customClasses={"text-sm m-2"}
        values={values}
      />

      {values[name].type === EXPRESSION && (
        <ManageExpression
          name="expression"
          expressionKey={`${name}.expression`}
          values={values}
          handleChange={(e) => handleChange(e, `${name}.expression`)}
          collections={collections}
          nodes={nodes}
          edges={edges}
        />
      )}
      {values[name].type === FIELDS &&
        (values.modelName ? (
          <SelectFieldModal
            name="fields"
            fieldKey={`${name}.fields`}
            values={values[name]}
            collections={collections}
            btnText="Manage Updates"
            title="Select fields to update"
            description="Select fields to update"
            modelName={values.modelName}
            handleChange={handleChange}
          />
        ) : (
          <div className="text-xs p-2 my-1 rounded-md border-2 border-red-500 text-red-600 text-center">
            Select a collection first
          </div>
        ))}
    </>
  );
};

export default GroupBy;
